// extracted by mini-css-extract-plugin
module.exports = {"theme":"#2b6fef"};